import { useEffect } from "react";
import { Select } from "antd";
import { useRequest } from "ahooks";
import { useAuthContext } from "@/components/auth/AuthProvider";
import { department as departmentService } from "@/services";

function DepartmentTypeSelect({ defaultValue, value, onChange }) {
  const auth = useAuthContext();
  const {
    data = [],
    loading,
    run,
  } = useRequest((params, token) => departmentService.listType(params, token), {
    manual: true,
  });
  useEffect(() => {
    if (auth) {
      const type = auth.roles === "admin" ? 1 : 2;
      run({ type }, auth.token);
    }
  }, [run, auth]);

  return (
    <Select
      style={{ width: 150 }}
      loading={loading}
      defaultValue={defaultValue}
      value={value}
      onChange={(value) => onChange(value)}
      allowClear
    >
      {data.map((t) => (
        <Select.Option key={`type-${t.id}`} value={t.id}>
          {t.name}
        </Select.Option>
      ))}
    </Select>
  );
}

export default DepartmentTypeSelect;
